import { customElement, property, state } from "lit/decorators.js";

import { css, html, nothing, TemplateResult } from "lit";
import { consume } from "@lit/context";
import { IFilterContext, filterContext } from "./filterContext";
import { LitElementBase } from "../LitElementBase";

@customElement("ehm-filter-results")
export class FilterResults extends LitElementBase {
  static styles = css`
    :host {
      display: block;
      margin-bottom: 5.5rem;
    }
    @media (max-width: 450px) {
      :host {
        margin-bottom: 2rem;
      }
    }
  `;

  @state()
  @consume({ context: filterContext, subscribe: true })
  private context?: IFilterContext;

  connectedCallback() {
    super.connectedCallback()
    const id = new URLSearchParams(window.location.search).get("id");
    if (id) {
      const element = document.getElementById(id);
      if (element) {
        document.addEventListener("DOMContentLoaded", () => {
          const elementPosition =
            element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - 108;
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        });
      }
    }
  }

  updated() {
    this.setAttribute("aria-live", "polite");
    this.setAttribute("aria-loading", this.context?.isLoading ? "true" : "false");
  }

  protected render(): TemplateResult | typeof nothing {
    return html` <slot></slot> `;
  }
}